// Replay of a finished solve: the move log played back on the grid, in place of the pad.
export function ReplayBar(props: {
  at: number;
  total: number;
  playing: boolean;
  onPlay: () => void;
  onStep: (delta: number) => void;
  onClose: () => void;
}) {
  const button =
    'h-11 min-w-11 rounded-btn border border-line bg-surface px-3 text-[14px] font-semibold text-ink disabled:opacity-45';
  return (
    <section aria-label="Replay" className="mx-3 flex flex-col gap-2 lg:mx-0">
      <p className="m-0 text-center text-[13px] text-muted tabular-nums" data-testid="replay-at">
        Move {props.at} of {props.total}
      </p>
      <div className="flex justify-center gap-2">
        <button
          type="button"
          aria-label="Back one move"
          disabled={props.at === 0}
          onClick={() => props.onStep(-1)}
          className={button}
        >
          ‹
        </button>
        <button type="button" onClick={props.onPlay} className={button}>
          {props.playing ? 'Pause' : props.at >= props.total ? 'Play again' : 'Play'}
        </button>
        <button
          type="button"
          aria-label="Forward one move"
          disabled={props.at >= props.total}
          onClick={() => props.onStep(1)}
          className={button}
        >
          ›
        </button>
        <button type="button" onClick={props.onClose} className={button}>
          Done
        </button>
      </div>
    </section>
  );
}
